import Svg, { Path } from "react-native-svg";
import { GetProps } from "tamagui";

const DigitalHealth = ({ color, ...props }: GetProps<typeof Svg>) => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <g clip-path="url(#clip0_6016_1859)">
      <Path
        d="M17.2727 16H2C1.44772 16 1 15.5523 1 15V2C1 1.44772 1.44772 1 2 1H20C20.5523 1 21 1.44772 21 2V13M5 21H17.2727M20.2727 21V21.0317M8.5 16H13.5V21H8.5V16ZM22 23H18.2727C17.7204 23 17.2727 22.5523 17.2727 22V14C17.2727 13.4477 17.7204 13 18.2727 13H22C22.5523 13 23 13.4477 23 14V22C23 22.5523 22.5523 23 22 23ZM11.3333 5C11.8856 5 12.3333 5.44772 12.3333 6V7.56667C12.3333 7.6219 12.3781 7.66667 12.4333 7.66667H14C14.5523 7.66667 15 8.11438 15 8.66667V9.33333C15 9.88562 14.5523 10.3333 14 10.3333H12.4333C12.3781 10.3333 12.3333 10.3781 12.3333 10.4333V12C12.3333 12.5523 11.8856 13 11.3333 13H10.6667C10.1144 13 9.66667 12.5523 9.66667 12V10.4333C9.66667 10.3781 9.6219 10.3333 9.56667 10.3333H8C7.44772 10.3333 7 9.88562 7 9.33333V8.66667C7 8.11438 7.44772 7.66667 8 7.66667H9.56667C9.6219 7.66667 9.66667 7.6219 9.66667 7.56667V6C9.66667 5.44772 10.1144 5 10.6667 5H11.3333Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6016_1859">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);

export default DigitalHealth;
